import type { InsiderTransation } from '@/pages/CompanyReport/components/InsiderTradingTransactions/redux/selectors';
import {
  Roles,
  TransactionValue,
} from '@/pages/CompanyReport/components/InsiderTradingTransactions';
import {
  TransactionColumn,
  TransactionTypePositioned,
  EntityColumn,
  InsiderTradingTable,
} from './styled';
import { useTranslation } from '@/hooks/useTranslation';

export interface InsiderTradingDataTableProps {
  data: InsiderTransation[];
  uniqueSymbol: string;
}

const InsiderTradingDataTable = ({
  data,
  uniqueSymbol,
}: InsiderTradingDataTableProps) => {
  const t = useTranslation();
  return (
    <InsiderTradingTable
      data-cy-id="insider-trading-table"
      columnWidths="0.7,1.3,1,0.6,0.6,0.6,0.6"
      columnTextAlignments="l,l,l,l,l,r,r"
    >
      <caption>
        {t('page.companyReport.ownership.insiderTradingVolume.caption', {
          uniqueSymbol,
        })}
      </caption>
      <thead>
        <tr>
          <th>
            {t('page.companyReport.ownership.insiderTradingVolume.heading1')}
          </th>
          <th>
            {t('page.companyReport.ownership.insiderTradingVolume.heading2')}
          </th>
          <th>
            {t('page.companyReport.ownership.insiderTradingVolume.heading3')}
          </th>
          <th>
            {t('page.companyReport.ownership.insiderTradingVolume.heading4')}
          </th>
          <th>
            {t('page.companyReport.ownership.insiderTradingVolume.heading5')}
          </th>
          <th>
            {t('page.companyReport.ownership.insiderTradingVolume.heading6')}
          </th>
          <th>
            {t('page.companyReport.ownership.insiderTradingVolume.heading7')}
          </th>
        </tr>
      </thead>
      <tbody>
        {data.map((n, i) => (
          <tr
            key={`InsiderTradingDataTableRow-${n.ownerName}-${n.shares}-${i}`}
          >
            <td>{n.filingDate}</td>
            <TransactionColumn>
              <TransactionTypePositioned type={n.transactionType}>
                {n.transactionType}
              </TransactionTypePositioned>
              <TransactionValue type={n.transactionType}>
                {n.transactionValue}
              </TransactionValue>
            </TransactionColumn>
            <td>{n.ownerName}</td>
            <EntityColumn>
              <span>{n.ownerType}</span>
            </EntityColumn>
            <td>
              <Roles boardTitle={n.boardTitle} teamTitle={n.teamTitle} />
            </td>
            <td>{n.shares}</td>
            <td>{n.priceMax}</td>
          </tr>
        ))}
      </tbody>
    </InsiderTradingTable>
  );
};

export default InsiderTradingDataTable;
